import * as React from 'react'

import { useAttachClientToPartnerProfile } from './hooks'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CRow,
} from '@coreui/react-pro'
import { submitEditPartner, setAttachClientToPartnerProfile } from './model'
import CIcon from '@coreui/icons-react'
import { cilListNumbered } from '@coreui/icons/js/free'

type Props = {
  className?: string
}

export const AttachClientToPartnerProfile = ({ className }: Props) => {
  let { attachClientToPartnerProfile, loading } =
    useAttachClientToPartnerProfile()

  const { partnerUserId, clientUserId } = attachClientToPartnerProfile

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    setAttachClientToPartnerProfile({
      ...attachClientToPartnerProfile,
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  const handlePartnerStatusChange = (objectKey: string, value: any) => {
    setAttachClientToPartnerProfile({
      ...attachClientToPartnerProfile,
      [objectKey]: value,
    })
  }

  return (
    <>
      <CCol xs={12} className={className}>
        <CCard className="mb-4">
          <CCardHeader className="d-sm-flex justify-content-between align-items-center">
            <strong>Attach client to partner</strong>
            <CButton
              color="secondary"
              className="me-2"
              title={'<- Back'}
              href={'/partner/'}
            >
              <CIcon icon={cilListNumbered} />
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CRow>
                <CCol xs={4}>
                  <div className="mb-3">
                    <CFormLabel htmlFor="address">partner ID</CFormLabel>
                    <CFormInput
                      type="text"
                      id="partnerUserId"
                      name="partnerUserId"
                      placeholder="123"
                      value={partnerUserId}
                      onChange={handleChange}
                    />
                  </div>
                </CCol>
                <CCol xs={4}>
                  <div className="mb-3">
                    <CFormLabel htmlFor="address">client ID</CFormLabel>
                    <CFormInput
                      type="text"
                      id="clientUserId"
                      name="clientUserId"
                      placeholder="234"
                      value={clientUserId}
                      onChange={handleChange}
                    />
                  </div>
                </CCol>
              </CRow>
              <CButton
                className="mb-3"
                disabled={loading}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish attach client ${attachClientToPartnerProfile.clientUserId} to a partner ${attachClientToPartnerProfile.partnerUserId}?`,
                    )
                  )
                    submitEditPartner(attachClientToPartnerProfile)
                }}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                Attach
              </CButton>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </>
  )
}

export const AttachClientToPartnerDetail = () => {
  return (
    <div>
      <CRow>
        <AttachClientToPartnerProfile></AttachClientToPartnerProfile>
      </CRow>
    </div>
  )
}
